import React from 'react';
import PropTypes from 'prop-types';
import OrderItem from './OrderItem';
import Row from '../Common/Grid/Row';
import Column from '../Common/Grid/Column';
import { OrderProductType, TextPairType } from './props';

/**
 * ProductList Component
 *
 * Displays a list of order items using the grid system.
 */
export default function ProductList({ orderProducts, text }) {
  if (!orderProducts || orderProducts.length === 0) {
    return null;
  }

  return (
    <Row>
      {orderProducts.map((orderProduct) => (
        <Column key={orderProduct.orderLineKey} xs="8">
          <OrderItem
            orderProduct={orderProduct}
            text={text}
          />
        </Column>
      ))}
    </Row>
  );
}

ProductList.propTypes = {
  orderProducts: PropTypes.arrayOf(OrderProductType),
  text: PropTypes.shape({
    size: TextPairType,
    color: TextPairType,
    item: TextPairType,
    storeItemNumber: TextPairType,
    finalSaleMessage: TextPairType,
    sku: TextPairType,
    cancelItem: TextPairType,
    returnForRefund: TextPairType,
    returnThisItem: TextPairType,
    exchangeButtonLabel: TextPairType,
    reserveAgain: TextPairType,
    itemsInReservation: TextPairType,
  }),
};

ProductList.defaultProps = {
  orderProducts: [],
  text: {},
};
